import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getTaskReportAvailableColumns } from './api';

export const path = '/ppr/task/report/list';

const PageTaskReports: React.FC = (props) => {
  const TaskReports = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getTaskReportAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <TaskReports {...props} />;
};

export default PageTaskReports;
